//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../Features/Features.ShipDesign.ManufacturingStockBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectNXObject.js";
import "../no/SelectFaceList.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"CutCount",1,0],[1,"CutOrientationAngle",0,"Expression",0],[1,"EndPositionOnGuide",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"GuideCurve",0,"Section",0],[1,"GuideOffset",0,"Expression",0],[0,"HorizontalReference",1,"Direction",0],[1,"ManufacturingInformation",0,"Features.ShipDesign.ManufacturingStockBuilder",0],[0,"OffsetDirectionReference",1,"Direction",0],[1,"PathGeometry",0,"SelectTaggedObjectList",0],[0,"PathReverseDirection",1,0],[1,"PlacementGeometry",0,"SelectDisplayableObjectList",0],[0,"ReferenceDirection",1,0],[0,"ReferencePoint",1,0],[1,"SelectEndLimit",0,"SelectNXObject",0],[1,"SelectStartLimit",0,"SelectNXObject",0],[1,"SelectTargetFace",0,"SelectFaceList",0],[1,"SketchBlock",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"SpaceBetweenCuts",0,"Expression",0],[0,"Spacing",1,0],[0,"SpacingReference",1,"Direction",0],[1,"StartPositionOnGuide",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"SymmetricOffsets",1,0],[0,"Version",0,0]],[],[]];
SPLM.Features.ShipDesign.EdgeCutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.EdgeCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.EdgeCutBuilder.VersionID = Object.freeze({
    "Nx85" : "Nx85", "Nx901" : "Nx901", "IgnoreEndCuts" : "IgnoreEndCuts", "CheckSplit" : "CheckSplit"});

SPLM.Features.ShipDesign.EdgeCutBuilder.ArraySpacing = Object.freeze({
    "EvenDistribution" : "EvenDistribution", "CustomDefined" : "CustomDefined"});

export default SPLM;